import InputEmail from './InputEmail.vue'
import InputPassword from './InputPassword.vue'

export default {
    components: {InputEmail, InputPassword},
    dependencies: ['service'],
    data: function () {
        return {
            error: '',
            user: {
                value: '', error: '', validator: {
                    rules: {
                        required: true,
                        minlength: 3
                    },
                    messages: {
                        required: "Please enter your user",
                        minlength: "Username should have at least 5 symbols"
                    }
                }
            },
            password: {
                value: '', error: '', validator: {
                    rules: {
                        required: true,
                        minlength: 6
                    },
                    messages: {
                        required: "Please provide a password",
                        minlength: "Password should have at least 6 symbols"
                    }
                }
            }
        }
    },
    mounted() {
        let username = sessionStorage.getItem('username');
        let password = sessionStorage.getItem('password');
        if (username && password) {
            this.doLogin(username, password);
        }
        this.service.ask().then(() => {
            this.$router.push("games");
        }).catch(()=>{});
    },
    methods: {
        sendLogin: function (e) {
            console.log('', process);
            if (!this.validate(this.user) | !this.validate(this.password))
                return;
            this.doLogin(this.user.value, this.password.value);
        },
        doLogin: function (username, password) {
            this.service.login(username, password).then(e => {
                sessionStorage.name = e.data.name;
                sessionStorage.currency = e.data.currency;
                this.$router.push("games");
            }, e => {
                this.error = 'USERNAME OR PASSWORD IS INCORRECT';
            });
        },
        validate: (field) => {
            field.error = '';
            let rules = field.validator.rules;
            let messages = field.validator.messages;
            for (let rule in rules) {
                if (rule === 'required' && rules[rule]) {
                    if (!field.value) {
                        field.error = messages[rule];
                        return false;
                    }
                } else if (rule === 'minlength') {
                    if (field.value.length < rules[rule]) {
                        field.error = messages[rule];
                        return false;
                    }
                } else if (rule === 'user') {
                    if (!rules[rule].test(field.value)) {
                        field.error = messages[rule];
                        return false;
                    }
                }
            }
            return true;
        }
    }
}